__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-manage-bookings-root'].baseUrl;
import iguazuConfiguration from './iguazu/config';
import iguazuRestConfiguration from './iguazu-rest/config';
import './products/productsConfig';
import ModuleContainer from './components/ManageBookingsRoot';
iguazuConfiguration();
iguazuRestConfiguration();
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/consumer-travel-base': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '4.3.2',
      module: require('@americanexpress/consumer-travel-base')
    },
    '@americanexpress/conditional-features': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.4.0',
      module: require('@americanexpress/conditional-features')
    },
    '@americanexpress/dls-react': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '7.14.0',
      module: require('@americanexpress/dls-react')
    },
    '@americanexpress/one-app-module-wrapper': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.6.2',
      module: require('@americanexpress/one-app-module-wrapper')
    },
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.8.0',
      module: require('@americanexpress/one-experiments')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    '@americanexpress/reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.8',
      module: require('@americanexpress/reactlytics')
    },
    '@americanexpress/travel-base': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '7.5.0',
      module: require('@americanexpress/travel-base')
    },
    '@americanexpress/travel-selectors': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '5.0.0',
      module: require('@americanexpress/travel-selectors')
    },
    '@americanexpress/travel-vacation-rentals-base': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.81.0',
      module: require('@americanexpress/travel-vacation-rentals-base')
    },
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.5',
      module: require('@americanexpress/data-manager-utils')
    },
    'axp-product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.20',
      module: require('axp-product-ducks')
    },
    'axp-wizard': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.0.0',
      module: require('axp-wizard')
    },
    'clsx': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.1',
      module: require('clsx')
    },
    'dompurify': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.5.8',
      module: require('dompurify')
    },
    'fetchye': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.0',
      module: require('fetchye')
    },
    'iguazu': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-holocron': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.8.2',
      module: require('iguazu-holocron')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'iguazu-rpc': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.1',
      module: require('iguazu-rpc')
    },
    'lodash': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '4.17.21',
      module: require('lodash')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.8.9',
      module: require('react-intl')
    },
    'moment-timezone': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.5.48',
      module: require('moment-timezone')
    },
    'react-content-loader': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.2.1',
      module: require('react-content-loader')
    },
    '@americanexpress/fetchye-amex': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.13.0',
      module: require('@americanexpress/fetchye-amex')
    },
    '@americanexpress/dls-icons': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '7.14.0',
      module: require('@americanexpress/dls-icons')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-manage-bookings-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-manage-bookings-root';
}